<template>
    <div>
        <template v-if="link">
            <a href="#" @click.prevent="editar()" class="h5 card-link mb-0 mr-3">
                <span v-if="agenda.tipo.fl_externo && agenda.centro">
                    {{ agenda.centro.st_centro_cirurgico }}
                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                </span>
                {{ agenda.search }}
            </a>
        </template>

        <template v-else>
            <span class="h5 card-link mb-0 mr-3">
                <span v-if="agenda.tipo.fl_externo && agenda.centro">
                    {{ agenda.centro.st_centro_cirurgico }}
                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                </span>
                {{ agenda.search }}
            </span>
        </template>

        <small v-if="agenda.unidade_operacao && agenda.unidade_operacao.st_sigla" class="badge badge-light mx-1">
            {{ agenda.unidade_operacao.st_sigla }}
        </small>
        <div class="text-muted small">
            <span v-if="show_periodo">
                {{ $util.getFormatDate(agenda.dt_vigencia_inicio) }}
                -
                {{ $util.getFormatDate(agenda.dt_vigencia_fim) }}
            </span>
            <span :class="show_periodo ? 'ml-3' : ''">
                {{ agenda.hr_inicio }} - {{ agenda.hr_termino }}
                <i class="fas fa-stopwatch ml-3"></i>
                {{ agenda.duracao }}h
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['agenda', 'link', 'show_periodo'],

    methods: { 
        editar() { 
            this.$emit('click', this.agenda);
        }
    }
}
</script>